export var getCaption = function (_a) {
    var value = _a.value, maxLength = _a.maxLength, label = _a.label;
    var selectedLength = value.length;
    if (selectedLength > maxLength) {
        throw new Error("Advanced filter error: selected length - " + selectedLength + " when max is " + maxLength + ". Checkout options or value.");
    }
    if (selectedLength === 0) {
        return label + " (None)";
    }
    if (selectedLength === maxLength) {
        return label + " (All)";
    }
    return label + " (" + selectedLength + " of " + maxLength + ")";
};
//# sourceMappingURL=getCaption.js.map